/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiWorkingHoursByDayFromJSON(json) {
    return StreemApiWorkingHoursByDayFromJSONTyped(json, false);
}
export function StreemApiWorkingHoursByDayFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'day': !exists(json, 'day') ? undefined : json['day'],
        'startTimeUtc': !exists(json, 'start_time_utc') ? undefined : json['start_time_utc'],
        'endTimeUtc': !exists(json, 'end_time_utc') ? undefined : json['end_time_utc'],
        'isHoliday': !exists(json, 'is_holiday') ? undefined : json['is_holiday'],
    };
}
export function StreemApiWorkingHoursByDayToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'day': value.day,
        'start_time_utc': value.startTimeUtc,
        'end_time_utc': value.endTimeUtc,
        'is_holiday': value.isHoliday,
    };
}
//# sourceMappingURL=StreemApiWorkingHoursByDay.js.map